import cloneDeep from 'lodash/cloneDeep';
import pagesModel from '@/mixins/pages-model';
import repliersModel from '@/mixins/repliers-model';
import filtersModel from '@/mixins/filters-model';
import usersModel from '@/mixins/users-model';
import WarRoomService from '@/services/WarRoomService';
import { mapState } from 'vuex';

export default {
  mixins: [
    pagesModel,
    repliersModel,
    filtersModel,
    usersModel,
  ],
  computed: {
    ...mapState('dashboard', [
      'isStaging',
    ]),
    ...mapState('filter', [
      'accountId',
      'universeId',
    ]),
    filterTitleLabel() {
      return `${this.filterLabel} - ${this.card.props.title}`;
    },
    showClearFilter() {
      return Object.keys(this.appliedFilter).length;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
    clearFilter() {
      this.tempFilter = {};
      this.applyFilter();
      this.$emit('applyFilter', {});
      this.closeDialog();
    },
    async applyFilter() {
      this.card.props.filter = { ...this.filterTikTokPages(this.tempFilter) };

      const newCardFilter = this.card.props.filter;
      this.card.props.filterId = await WarRoomService.encodeFilter({
        account_id: this.accountId,
        is_staging: this.isStaging,
        filter: JSON.stringify(newCardFilter),
      });
      this.$emit('applyFilter', this.tempFilter);
      this.closeDialog();
    },
    clearChangesFilter() {
      this.tempFilter = cloneDeep(this.appliedFilter);
      this.changeOnPageFilter = false;
    },
    filterTikTokPages(filters) {
      if (!filters?.pages && Boolean(this.card?.control?.tiktok.hideInChannel)) {
        const pagesList = [];
        const channelsList = new Set();
        this.applyControl = true;
        this.pagesFormatted.forEach(page => {
          pagesList.push(page.id);
          channelsList.add(page.channel);
        });
        return { ...filters, pages: { value: pagesList }, channels: { value: [...channelsList] } };
      }
      return { ...filters };
    },
  },
};
